import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Trovity from 'src/assets/Buy_Policy_Images/TrovityImage.svg'
import Support from 'src/assets/Buy_Policy_Images/Support.svg'
import Mail from 'src/assets/Buy_Policy_Images/Mail.svg'
import IRDAI from 'src/assets/Buy_Policy_Images/IRDAI.svg'
import { CONTACT } from 'src/utils/constants/common'
import { useHistory } from 'react-router-dom'

const Footer = () => {
  const classes = useStyles()
  const history = useHistory()

  const handlePrivacyPolicy = () => {
    history.push(
      '/individual/dashboard/buyPolicy/terms-conditions-privacy-policy'
    )
  }
  return (
    <>
      <div className={`component-container ${classes.rootContainer}`}>
        <div className={'component-element'}>
          <div className={classes.container}>
            <div className={classes.infoContainer}>
              <div
                className={`${classes.infoContent} ${classes.trovityImageContainer}`}
              >
                <div className={classes.trovityImageContent}>
                  <img
                    src={Trovity}
                    className={classes.trovityImage}
                    width='150'
                    height='25'
                    alt={'Trovity'}
                  />
                </div>
              </div>

              <div
                className={`${classes.infoContent} ${classes.basicInfoContainer}`}
              >
                <div className={classes.basicDetailsContainer}>
                  <span className={classes.basicDetails}>
                    CIN:U66000TG2021PTC156842
                  </span>
                  <span className={classes.basicDetails}>
                    IRDI Reg No:848 Direct(Life& General),Valid upto 13-09-2025
                  </span>
                </div>
              </div>

              <div
                className={`${classes.infoContent} ${classes.categoryDetailsContainer}`}
              >
                <div className={classes.basicDetailsContainer}>
                  <span className={classes.basicDetails}>
                    Category: Direct Broker(Life&General)
                  </span>
                  <span className={classes.basicDetails}>
                    Principal Officer: K SuryaRao
                  </span>
                  <span className={classes.basicDetails}>
                    Mail Id:
                    <span className={classes.trovityMail}>
                      &nbsp;po@trovity.com
                    </span>
                  </span>
                </div>
              </div>

              <div
                className={`${classes.infoContent} ${classes.contactContent}`}
              >
                <div
                  className={`${classes.basicDetailsContainer} ${classes.contactDetailsContainer}`}
                >
                  <div className={classes.contactDetails}>
                    <div className={classes.contactImageContainer}>
                      <img
                        src={Support}
                        className={classes.contactImage}
                        alt={'Support'}
                      />
                    </div>
                    <div className={classes.contactTextContainer}>
                      <span className={classes.contactHeading}>
                        24/7 Support
                      </span>
                      <span className={classes.contentInfo}>
                        {CONTACT.Contact}
                      </span>
                    </div>
                  </div>

                  <div className={classes.contactDetails}>
                    <div className={classes.contactImageContainer}>
                      <img
                        src={Mail}
                        className={classes.contactImage}
                        alt={'Mail'}
                      />
                    </div>
                    <div className={classes.contactTextContainer}>
                      <span className={classes.contactHeading}>Email To</span>
                      <span className={classes.contentInfo}>
                        info@trovity.com
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.termsRow}>
              <div className={classes.irdaiImageContainer}>
                <img src={IRDAI} className={classes.irdaiImage} />
              </div>

              <div className={classes.termsAndConditionsContainer}>
                <div className={classes.mainTextContainer}>
                  <span className={classes.mainTermsText}>
                    *All discounts provided by insurers as per{' '}
                    <span className={classes.irdaiApprovedText}>
                      IRDAI approved
                    </span>{' '}
                    insurance plans.Standard T&C apply.
                  </span>
                  <span
                    className={classes.privacyPolicyText}
                    onClick={handlePrivacyPolicy}
                  >
                    Terms & Conditions, Privacy Policy.
                  </span>
                </div>
                <div className={classes.separator}></div>

                <div className={classes.subTermsText}>
                  Insurance is the subject matter of solicitation. For more
                  details on policy terms, conditions, exclusions, limitations,
                  please refer/read policy brochure carefully before concluding
                  sale. Visitors are hereby informed that their information
                  submitted on the website may be shared with insurers for
                  soliciting insurance policies. The product information for
                  comparison displayed on this website is of the insurers with
                  whom our company has an agreement. Product information is
                  authentic and solely based on the information received from
                  the Insurer.
                </div>
              </div>
            </div>

            <div className={classes.footerContentCopyRight}>
              <p className={classes.footerActionCopyRight}>
                © 2023 Copyrights reserved by Trovity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Footer
const useStyles = makeStyles({
  rootContainer: {
    backgroundColor: '#F1F1F1',
    boxShadow: '0px 0px 10px 0px #00000026',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    '@media (max-width:767px)': {
      alignItems: 'center',
    },
  },
  infoContent: {
    width: '25%',
    '@media (max-width:1024px) and (min-width:768px)': {
      width: '50%',
    },
    '@media (max-width:767px)': {
      width: '100%',
    },
  },
  trovityImage: {
    maxWidth: '100%',
  },
  trovityImageContent: {
    paddingTop: '5px',
    display: 'flex',
    margin: '5px',
    height: '100%',
    alignItems: 'center',
  },
  basicDetailsContainer: {
    border: '1px solid  #B8B8B8',
    backgroundColor: 'white',
    padding: '5px 20px 5px 20px',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '3px',
    // minHeight: '60px',
    margin: '5px',
    height: '100%',
  },
  basicDetails: {
    fontSize: '12px',
    fontWeight: 400,
  },
  contactDetailsContainer: {
    background:
      'linear-gradient(0deg, #EBEBEB -33.33%, rgba(235, 235, 235, 0) 87.68%)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  contactHeading: {
    fontSize: '12px',
    opacity: '0.7',
  },
  contactDetails: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contactImageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contactImage: {
    height: '27px',
    width: '27px',
  },
  contentInfo: {
    fontSize: '15px',
    fontWeight: 'bold',
  },
  irdaiImage: {
    backgroundColor: 'white',
    border: '1px solid #CBCBCB',
    padding: '11px 8px 12px 14px',
  },
  irdaiImageContainer: {
    zIndex: '2',
  },
  footerActionCopyRight: {
    fontSize: '12px',
    opacity: '0.7',
  },
  footerContentCopyRight: {
    textAlign: 'center',
  },
  contactTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  trovityMail: {
    textDecoration: 'underLine',
  },
  termsAndConditionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '10px',
  },
  mainTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  mainTermsText: {
    fontSize: '16px',
  },
  irdaiApprovedText: {
    color: '#B92351',
  },
  privacyPolicyText: {
    fontSize: '13px',
    color: '#1097E2',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  separator: {
    border: '1px solid #B8B8B8',
    margin: '10px 0',
  },
  subTermsText: {
    fontSize: '11px',
    opacity: '0.7',
  },
  categoryDetailsContainer: {
    '@media (min-width:768px)': {
      width: '21.974%',
    },
  },
  basicInfoContainer: {
    '@media (min-width:768px)': {
      width: '32.393%',
    },
  },
  trovityImageContainer: {
    '@media (min-width:768px)': {
      width: '13.654%',
    },
  },
  contactContent: {
    '@media (min-width:768px)': {
      width: '31.979%',
    },
  },
  termsRow: {
    display: 'flex',
    position: 'relative',
    marginTop: '50px',
  },
})
